// extracted by mini-css-extract-plugin
export default {"root":"topPanel_root__JKXoy section-wrapper","heading":"topPanel_heading__3QtmA","title":"topPanel_title__EaMnb title","description":"topPanel_description__GHeHL"};